import { useTRPCAPI, useTRPCQuery } from '../../../../trpc/trpc';
import { clampMarketsRangeDays } from '../marketsRange';

interface UseTopCountriesProps {
  date?: Date;
  rangeDays?: number;
  limit?: number;
  /** Skips the call when the plan does not include the country breakdown. */
  enabled?: boolean;
}

/**
 * Countries the followed tracks and artists are seen in.
 *
 * No `shareToken` here on purpose: `markets.*` aggregates over "what this user
 * follows", so the router answers FORBIDDEN to a share token.
 */
export const useTopCountries = ({ date, rangeDays = 7, limit = 10, enabled = true }: UseTopCountriesProps) => {
  const trpcMusicAPI = useTRPCAPI();

  return useTRPCQuery({
    ...trpcMusicAPI.markets.topCountries.queryOptions({ date, rangeDays: clampMarketsRangeDays(rangeDays), limit }),
    enabled,
  });
};
